import arrayMove from 'array-move';
import { generateTabProduct } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/generator';

const useProductTab = () => {
  const handleOnReselect = (value, onChange, products) => {
    if (onChange) {
      const _products = products.map((i) => {
        return { ...i, draggableId: i.uuid };
      });
      onChange(_products);
    }
  };

  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  const handleOnAdd = (value, onChange, index) => {
    //const pc = generateNewContentPage();
    //const { pc } = ;
    onChange([...(value || []), generateTabProduct(index + 1)]);
  };
  return {
    handleOnDelete,
    handleOnSort,
    handleOnReselect,
    handleOnAdd,
  };
};
export { useProductTab };
